/**
 * Bio Modal
 * Handles modal functionality for bio cards
 */

class BioModal {
	constructor() {
		this.modal = document.getElementById( 'bio-modal' );
		this.backdrop = null;
		this.closeBtn = null;
		this.prevBtn = null;
		this.nextBtn = null;
		this.bioCards = [];
		this.currentIndex = 0;

		if ( this.modal ) {
			this.init();
		}
	}

	init() {
		// Get all bio card elements
		this.bioCards = Array.from( document.querySelectorAll( '[data-bio-card]' ) );

		// Get modal elements
		this.backdrop = this.modal.querySelector( '.bio-modal__backdrop' );
		this.closeBtn = this.modal.querySelector( '.bio-modal__close' );
		this.prevBtn = this.modal.querySelector( '[data-nav="prev"]' );
		this.nextBtn = this.modal.querySelector( '[data-nav="next"]' );

		// Bind events
		this.bindEvents();
	}

	bindEvents() {
		// Click on bio cards to open modal
		this.bioCards.forEach( ( card, index ) => {
			const cardLink = card.querySelector( '.bio-card__link' );
			if ( cardLink ) {
				cardLink.addEventListener( 'click', ( e ) => {
					e.preventDefault();
					this.open( index );
				} );
			}
		} );

		// Close modal
		if ( this.closeBtn ) {
			this.closeBtn.addEventListener( 'click', () => this.close() );
		}

		if ( this.backdrop ) {
			this.backdrop.addEventListener( 'click', () => this.close() );
		}

		// Navigation
		if ( this.prevBtn ) {
			this.prevBtn.addEventListener( 'click', () => this.navigate( 'prev' ) );
		}

		if ( this.nextBtn ) {
			this.nextBtn.addEventListener( 'click', () => this.navigate( 'next' ) );
		}

		// ESC key to close
		document.addEventListener( 'keydown', ( e ) => {
			if ( e.key === 'Escape' && this.modal.classList.contains( 'show' ) ) {
				this.close();
			}
		} );

		// Arrow keys for navigation
		document.addEventListener( 'keydown', ( e ) => {
			if ( this.modal.classList.contains( 'show' ) ) {
				if ( e.key === 'ArrowLeft' ) {
					this.navigate( 'prev' );
				} else if ( e.key === 'ArrowRight' ) {
					this.navigate( 'next' );
				}
			}
		} );
	}

	open( index ) {
		this.currentIndex = index;
		this.updateModalContent();
		this.modal.classList.add( 'show' );
		document.body.classList.add( 'modal-open' );
	}

	close() {
		this.modal.classList.remove( 'show' );
		document.body.classList.remove( 'modal-open' );
	}

	navigate( direction ) {
		if ( direction === 'prev' ) {
			this.currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.bioCards.length - 1;
		} else if ( direction === 'next' ) {
			this.currentIndex = this.currentIndex < this.bioCards.length - 1 ? this.currentIndex + 1 : 0;
		}
		this.updateModalContent();
	}

	updateModalContent() {
		const currentCard = this.bioCards[this.currentIndex];
		if ( !currentCard ) return;

		// Get card data
		const name = currentCard.querySelector( '.bio-card__name' )?.textContent || '';
		const title = currentCard.querySelector( '.bio-card__title' )?.textContent || '';
		const image = currentCard.querySelector( '.bio-card__image' )?.src || '';
		const description = currentCard.dataset.bioDescription || '<p>No bio available.</p>';

		// Update modal content
		const modalName = this.modal.querySelector( '.bio-modal__name' );
		const modalTitle = this.modal.querySelector( '.bio-modal__title' );
		const modalImage = this.modal.querySelector( '.bio-modal__image' );
		const modalDescription = this.modal.querySelector( '.bio-modal__description' );

		if ( modalName ) modalName.textContent = name;
		if ( modalTitle ) modalTitle.textContent = title;
		if ( modalImage ) modalImage.src = image;
		if ( modalDescription ) modalDescription.innerHTML = description;
	}
}

// Initialize on DOM ready
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', () => {
		new BioModal();
	} );
} else {
	new BioModal();
}

export default BioModal;
